import React from 'react';
import { MessageCircle, Youtube, Facebook, Instagram, Music2 } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ivory text-charcoal/80 pt-20 pb-10 border-t border-forest/10" data-id="element-343">
      <div className="max-w-[1280px] mx-auto px-8 md:px-16 lg:px-24" data-id="element-344">
        {/* Top grid: 4 logical columns with social closer to badges */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-x-8 pb-12" data-id="element-345">
          {/* CONTACT */}
          <div className="lg:col-span-4" data-id="element-346">
            <h4 className="font-display text-xs font-semibold tracking-[0.25em] text-gold-dark uppercase mb-8" data-id="element-347">
              Contact
            </h4>
            <div className="space-y-5 text-[15px] leading-relaxed font-sans text-charcoal/80" data-id="element-348">
              <p data-id="element-349">
                MY HEALING HEARTS S.R.L., CIF:{' '}
                <span className="whitespace-nowrap" data-id="element-350">50131347</span>.
              </p>
              <p data-id="element-351">
                Adresa: Topolovățu Mare, Str. Buziașului,
                <br data-id="element-352" />
                Nr. 394, Județul Timiș, România
              </p>
              <p data-id="element-353">Telefon: +40 771 946 011</p>
              <p className="break-all" data-id="element-354">email: contact@mihaelaiovu.ro</p>
            </div>
          </div>

          {/* LEGAL */}
          <div className="lg:col-span-3" data-id="element-355">
            <h4 className="font-display text-xs font-semibold tracking-[0.25em] text-gold-dark uppercase mb-8" data-id="element-356">
              Legal
            </h4>
            <ul className="space-y-5 text-[15px] font-sans tracking-wider uppercase text-charcoal/80" data-id="element-357">
              <li data-id="element-358">
                <a href="#" className="hover:text-forest transition-colors no-underline" data-id="element-359">
                  Termeni și Condiții
                </a>
              </li>
              <li data-id="element-360">
                <a href="#" className="hover:text-forest transition-colors no-underline" data-id="element-361">
                  Politica de Confidențialitate
                </a>
              </li>
              <li data-id="element-362">
                <a href="#" className="hover:text-forest transition-colors no-underline" data-id="element-363">
                  Politica de Cookies
                </a>
              </li>
              <li data-id="element-364">
                <a href="#" className="hover:text-forest transition-colors no-underline" data-id="element-365">
                  ANPC
                </a>
              </li>
            </ul>
          </div>

          {/* SOCIAL + BADGES (closer together) */}
          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-4" data-id="element-366">
            {/* SOCIAL MEDIA */}
            <div data-id="element-367">
              <h4 className="font-display text-xs font-semibold tracking-[0.25em] text-gold-dark uppercase mb-8" data-id="element-368">
                Social Media
              </h4>
              <ul className="space-y-5 text-[15px] font-sans text-charcoal/80" data-id="element-369">
                <li data-id="element-370">
                  <a href="https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201." target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-forest transition-colors no-underline" data-id="element-371">
                    <MessageCircle className="w-5 h-5 text-gold-dark" data-id="element-372" />
                    WhatsApp
                  </a>
                </li>
                <li data-id="element-373">
                  <a href="#" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-forest transition-colors no-underline" data-id="element-374">
                    <Youtube className="w-5 h-5 text-gold-dark" data-id="element-375" />
                    Youtube
                  </a>
                </li>
                <li data-id="element-376">
                  <a href="#" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-forest transition-colors no-underline" data-id="element-377">
                    <Facebook className="w-5 h-5 text-gold-dark" data-id="element-378" />
                    Facebook
                  </a>
                </li>
                <li data-id="element-379">
                  <a href="#" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-forest transition-colors no-underline" data-id="element-380">
                    <Instagram className="w-5 h-5 text-gold-dark" data-id="element-381" />
                    Instagram
                  </a>
                </li>
                <li data-id="element-382">
                  <a href="#" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-forest transition-colors no-underline" data-id="element-383">
                    <Music2 className="w-5 h-5 text-gold-dark" data-id="element-384" />
                    Tiktok
                  </a>
                </li>
              </ul>
            </div>

            {/* ANPC BADGES */}
            <div className="flex flex-col gap-4 pt-1" data-id="element-385">
              <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow w-full border border-forest/10" aria-label="ANPC - Soluționarea Alternativă a Litigiilor" data-id="element-386">
                <img src="https://cdn.magicpatterns.com/uploads/u4nheP1G9zRf6Y3ubqSDUe/ANPC.webp" alt="ANPC - Soluționarea Alternativă a Litigiilor" className="w-full h-auto block" data-id="element-387" />
              </a>
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow w-full border border-forest/10" aria-label="Soluționarea Online a Litigiilor" data-id="element-388">
                <img src="https://cdn.magicpatterns.com/uploads/xBsFmTaCtZscat8GxnFfkk/SAL.jpg" alt="Soluționarea Online a Litigiilor" className="w-full h-auto block" data-id="element-389" />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-forest/15" data-id="element-390"></div>

        {/* Bottom copyright */}
        <div className="pt-8 text-center" data-id="element-391">
          <p className="text-[17px] font-sans text-charcoal/75 leading-relaxed" data-id="element-392">
            © Copyright 2026.{' '}
            <span className="font-semibold text-forest" data-id="element-393">
              MY HEALING HEARTS S.R.L.
            </span>{' '}
            Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>;
}